document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-sfl-carousel]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-sfl-slide]');
    var dots = root.querySelectorAll('[data-sfl-dot]');
    var caption = root.querySelector('.sfl-showcase-caption');
    if (slides.length < 2) return;
    var index = 0;
    function show(i) {
      index = i;
      slides.forEach(function (img, n) {
        img.style.opacity = n === i ? '1' : '0';
      });
      dots.forEach(function (dot, n) {
        dot.classList.toggle('border-gold', n === i);
        dot.classList.toggle('bg-gold', n === i);
        dot.classList.toggle('border-bone/30', n !== i);
      });
      if (caption && slides[i]) {
        caption.textContent = slides[i].dataset.sflCaption || '';
      }
    }
    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        show(n);
      });
    });
    show(0);
    var timer = setInterval(function () {
      show((index + 1) % slides.length);
    }, 4000);
    root.addEventListener('mouseenter', function () {
      clearInterval(timer);
    });
  });
});

// scroll animate js
document.addEventListener('DOMContentLoaded', function () {
  const scrollTriggers = document.querySelectorAll('.scroll-trigger');
  if (!scrollTriggers.length) return;
  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    }
  );
  scrollTriggers.forEach(function (element) {
    observer.observe(element);
  });
});


// sfl_tagline_banner section js 
document.addEventListener('DOMContentLoaded', function () {
  var revealBlocks = document.querySelectorAll('[data-word-reveal]');
  if (!revealBlocks.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {

        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }

      });
    },
    {
      threshold: 0.2,
      rootMargin: '0px 0px -40px 0px'
    }
  );
  revealBlocks.forEach(function (block) {
    observer.observe(block);
  });

});